import type { ContentRatingDetails } from '@communities/community/domain';
import { withAppInsightsTracking } from '@core/logging/withAppInsightsTracking';

import { RichContentRating } from './RichContentRating';
import { SimpleContentRating } from './SimpleContentRating';

interface ContentRatingDisplayProps {
  contentRating?: ContentRatingDetails | null;
  pgRating?: string;
  ratingUrl?: string;
  ratingIconUrl?: string;
  genres?: string[];
  className?: string;
}

/**
 * ContentRatingDisplay
 *
 * Delegates to RichContentRating when rich Microsoft Store data is present,
 * otherwise falls back to SimpleContentRating (text only) path.
 * Returns null if neither rating form is available.
 *
 * This extraction removes previous complexity suppression and follows
 * component extraction guidelines (component-strategy.mdc).
 */
function ContentRatingDisplayComponent({ contentRating, pgRating, ratingUrl, ratingIconUrl, genres, className }: ContentRatingDisplayProps) {
  if (contentRating) {
    return <RichContentRating className={className} contentRating={contentRating} genres={genres} ratingIconUrl={ratingIconUrl} ratingUrl={ratingUrl} />;
  }

  if (pgRating) {
    return <SimpleContentRating className={className} genres={genres} pgRating={pgRating} />;
  }

  return null;
}

export const ContentRatingDisplay = withAppInsightsTracking(ContentRatingDisplayComponent, 'ContentRatingDisplay');
